import { useTranslation } from "react-i18next";
import { CompanionFallback } from "./companionFallback";

interface MochiFallbackButtonProps {
  onClick: () => void;
  /** When "companion", renders the companion rig's flat SVG instead of the
   *  legacy Mochi circle emoji. Any other value (or omission) keeps the
   *  legacy look unchanged. */
  avatar?: string;
  /** Hue for the companion SVG palette; ignored for the legacy avatar. */
  hue?: number;
  ariaLabel?: string;
  ariaExpanded?: boolean;
  ariaControls?: string;
}

/** Flat 2D Mochi used when WebGL is unavailable or the scene is loading.
 *  Keeps the launcher + popover fully functional with no GPU. */
export function MochiFallbackButton({
  onClick,
  avatar,
  hue = 250,
  ariaLabel,
  ariaExpanded,
  ariaControls,
}: MochiFallbackButtonProps) {
  const { t } = useTranslation();
  const isCompanion = avatar === "companion";
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel ?? t("mochi.open")}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      className={
        isCompanion
          ? "size-14 rounded-full overflow-hidden shadow-lg ring-2 ring-white/70 flex items-center justify-center"
          : "size-14 rounded-full bg-[#F28C28] shadow-lg ring-2 ring-white/70 flex items-center justify-center text-2xl"
      }
    >
      {isCompanion ? <CompanionFallback hue={hue} /> : <span aria-hidden>🟠</span>}
    </button>
  );
}
